// @flow
export default class MasonryLayout {}
